import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  margin-top: 16px;
  padding-top: 8px;
  border-top: 1px solid #babaca;

  section {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    h1 {
      font-size: 22px;
    }
    p {
      font-size: 0.85rem;
      margin: 4px 0;
    }
    .add {
      display: flex;
      align-items: center;
      justify-content: center;
      .link {
        font-size: 14px;
      }
    }
  }
`;
